import About from '@/pages/About/About';
import PageSEO from '@/shared/PageSEO/PageSEO';

export default function AboutPage() {
  return (
    <>
      <PageSEO title="About us - Meet the Rockalingua Team" />
      <About />
    </>
  );
}
